import axios from "axios";

export function getUserAuthStatus(url) {
  return axios({
    method: "get",
    url: url,
  });
}
